import { Button, Dropdown, Icon } from '@symphony-ui/uitoolkit-components';
import useOption from 'components/customHooks';
import * as React from 'react';
import PartyCreateModal from './PartyCreateModal';
import Party from '../../../../../../models/Party';
const BookrunnerPicker = ({ disabled, initialNames, initialPartyId, onChangeParty }) => {
    const [partyId, setPartyId] = React.useState(initialPartyId);
    const [createModal, setCreateModal] = React.useState(false);
    const partyOptions = useOption('/syndicate/parties/options');
    const callbackCreate = React.useCallback((party) => {
        onChangeParty({ target: { value: party } });
    }, [onChangeParty]);
    const onChangePartyDropdown = React.useCallback((event) => {
        console.log("Party changed to: %o", event);
        setPartyId(event.target.value?.value);
        const updatedParty = event.target.value !== null ? new Party({ id: event.target.value.value, name: event.target.value.label, names: initialNames ?? [] }) : undefined;
        onChangeParty({ target: { value: updatedParty } });
    }, [initialNames, onChangeParty]);
    const onClearParty = React.useCallback(() => {
        setPartyId(undefined);
        onChangeParty({ target: { value: undefined } });
    }, [onChangeParty]);
    const onClickCreate = React.useCallback(() => {
        setCreateModal(true);
    }, []);
    const ddvalue = React.useMemo(() => partyOptions.find(o => 'value' in o && o.value === partyId), [partyId, partyOptions]);
    const disabledCreate = React.useMemo(() => partyId !== undefined, [partyId]);
    return React.createElement(React.Fragment, null,
        createModal ?
            React.createElement(PartyCreateModal, { initialNames: initialNames, onClose: () => setCreateModal(false), callback: callbackCreate }) : undefined,
        React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
            React.createElement("div", { style: { width: '100%' } },
                React.createElement(Dropdown, { isDisabled: disabled, isInputClearable: true, label: "Existing Party", name: "names", onChange: onChangePartyDropdown, onClear: onClearParty, options: partyOptions, value: ddvalue })),
            React.createElement("div", { style: { alignSelf: 'end', marginLeft: '0.5rem' } },
                React.createElement(Button, { disabled: disabledCreate, iconButton: true, onClick: onClickCreate, size: 'small' },
                    React.createElement(Icon, { iconName: 'plus' })))));
};
export default BookrunnerPicker;
